import React from 'react';
import { Filter, ReferenceInput, SelectInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import UserAutocompleteInput from '../../../../commonComponents/UserAutocompleteInput';

const DailyQuestionsReportsFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Question of the day" source="question_id" reference="admin/daily-questions" alwaysOn>
      <SelectInput optionText="text" />
    </ReferenceInput>
    <UserAutocompleteInput label="User ID" source="user_id" alwaysOn />
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
  </Filter>
);

export default DailyQuestionsReportsFilter;
